<footer class="footer">
    <div class="container">
        <p class="m-0">© 2021 Fly Net. Բոլոր իրավունքները պաշտպանված են:</p>
    </div>
</footer>